function formatDateTime(date) {
  let dateObj;

  // 處理 Day.js 物件
  if (date && typeof date === "object" && date.$isDayjsObject) {
    dateObj = date.toDate(); // 將 Day.js 轉換為 Date 物件
  }
  // 處理字串格式
  else if (typeof date === "string") {
    dateObj = new Date(date);
  }
  // 處理 Date 物件
  else if (date instanceof Date) {
    dateObj = date;
  }
  // 處理其他情況
  else {
    return null;
  }

  // 檢查日期是否有效
  if (isNaN(dateObj)) return null;

  return (
    dateObj.getFullYear() +
    "/" +
    String(dateObj.getMonth() + 1).padStart(2, "0") +
    "/" +
    String(dateObj.getDate()).padStart(2, "0") +
    " " +
    String(dateObj.getHours()).padStart(2, "0") +
    ":" +
    String(dateObj.getMinutes()).padStart(2, "0") +
    ":" +
    String(dateObj.getSeconds()).padStart(2, "0")
  );
}

export default formatDateTime;

// 使用範例：
// formatDateTime(dayjs()) -> "2025/08/05 17:10:20"
// formatDateTime("Tue, 15 Jul 2025 06:05:00 GMT") -> "2025/07/15 06:05:00"
// formatDateTime(new Date()) -> "2025/08/05 17:10
